export const ALL_SECTION_ADDED_LABEL = 'All sections added! Looks good.';
